export default function getAssignmentStatusNames(status) {
  return AssignmentStatusNames[status] || "Rechazada por el paciente";
}

export const AssignmentStatusNames = {
  "66182a677b4df03548c40406": "No respondido por el paciente",
  "6618298e7b4df03548c403ff": "Paciente repetido",
  "66182a197b4df03548c40404": "En espera por aprobación del paciente",
  "661829ad7b4df03548c40400": "Entrega fallida",
  "66182a7e7b4df03548c40407": "No recibido por el paciente",
  "661829c97b4df03548c40401": "No aceptada por el paciente",
  "661829e67b4df03548c40402": "En preparación",
  "66182a037b4df03548c40403": "En reparto",
  "66182a497b4df03548c40405": "Entregado",
  "68e4a759759d16f7e83d4815": "Dirección errónea",
  "68e4a794759d16f7e83d4816": "Segundo intento de entrega",
  "68e4a7c8759d16f7e83d4817": "Tercer intento de entrega",
  1: "Entregado",
  0: "En espera por aprobación del paciente",
  2: "Entrega fallida",
  3: "En reparto",
  4: "No aceptada por el paciente",
};
